import { Component, inject, } from "@angular/core";
import { BaseChartDirective } from "ng2-charts";
import { MagicChartBaseComponent } from "./magic-chart-base.component";
import { environment } from "../../../../../environments/environment";
import { DeckCardTagType } from "@apiserver-rest/ponder-data-client-base";
import { debounceTime, Subscription } from "rxjs";
import { DeckCardEvent } from "@ponder-core/events/deck.events";
import { DeckLayerName } from "@apiserver-rest/ponder-data-client";
import { EventBroker } from "@ponder-core/events/eventBroker";

@Component({
    selector: "magic-mana-curve-chart",
    imports: [BaseChartDirective],
    templateUrl: "./magic-mana-curve-chart.component.html"
})
export class MagicManaCurveChartComponent extends MagicChartBaseComponent {

    public averageManaValue!: string;
    public medianManaValue!: string;
    public landsInHand!: string;
    public nonlandCount: number = 0;
    
    private deckCardSub!: Subscription;

    public override ngOnInit(): void {
        this.dataLabel = "Mana Curve";
        this.lineBorderWidth = 0;
        this.lineBorderRadius = 5;
        this.xGridLineVisible = false;
        
        super.ngOnInit();
        this.updateData();

        // ??? undefined ???
        this.deckCardSub = this.events.deck.deckCardEvent
            .pipe(debounceTime(500))
            .subscribe({
                next: (event: DeckCardEvent) => {
                    if (event.layer === DeckLayerName.Mainboard) {
                        this.updateData();
                    }
                }
            });
    }

    public ngOnDestroy(): void {
        this.deckCardSub.unsubscribe();
    }

    private updateData(): void {
        var cmcTallies: number[] = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
        var allCmc: number[] = [];

        var totalManaValue = 0;
        var totalLandCount = 0;
        var totalNonLandCount = 0;
        var openingHandCard = 0;

        // ---------------------------------------------------------------------------------
        // Compile Data

        this.deckComponent.mainLayer.cards?.forEach(c => {
            var magicCard = c.card.item.data?.magic;

            if (!magicCard) {
                return;
            }

            var count = c.count + c.specialCount;

            if (c.tag != DeckCardTagType.Commander && c.tag != DeckCardTagType.Oathbreaker && c.tag != DeckCardTagType.SignatureSpell) {
                openingHandCard += count;
            }

            if (magicCard.faces![0].typeLine!.indexOf('Land') >= 0) {
                totalLandCount += count;
            } else {
                totalNonLandCount += count;

                var cmc = magicCard.manaValue ?? 0;
                
                if (cmc || (cmc == 0)) {
                    while (cmc > cmcTallies.length) {
                        cmcTallies.push(0);
                    }

                    cmcTallies[cmc] += count;
                    totalManaValue += cmc * count;

                    while (count > 0) {
                        allCmc.push(cmc);
                        count--;
                    }
                }
            }
        });

        // ---------------------------------------------------------------------------------
        // Add to Chart

        this.resetData();
        this.addDataPoint(totalLandCount, "Lands", environment.colors.chart.default);

        cmcTallies.forEach((value: number, index: number) => {
            this.addDataPoint(value, index.toString(), environment.colors.chart.default);
        });
        
        // ---------------------------------------------------------------------------------
        // Get Summary Results

        if (totalNonLandCount > 0) {
            this.averageManaValue = (totalManaValue / totalNonLandCount).toFixed(1);
        }

        if (allCmc.length > 0) {
            allCmc.sort((a: number, b: number) => {
                return (a < b ? -1: 1);
            });
            
            var index = Math.floor(allCmc.length * 0.5);
            this.medianManaValue = allCmc[index].toFixed(0);
        }

        if (openingHandCard > 0) {
            var percentageIndividualCardInHand = 1.0 / openingHandCard;
            var handSize = 7;
            var chanceOfLandInHand = percentageIndividualCardInHand * totalLandCount * handSize;

            this.landsInHand = `${Math.round(chanceOfLandInHand)}`;
        }

        this.nonlandCount = totalNonLandCount;
    }
}